import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '../../../../../shared/translate/translate.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material';
import { DecourseCommentAddComponent } from './decourse-comment-add.component';

@NgModule({
  declarations: [DecourseCommentAddComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule
  ],
  exports: [DecourseCommentAddComponent]
})
export class DecourseCommentAddModule { }
